import React, { useState, useEffect } from "react";
import Layout from "../../../../Components/Layout";
import detailsClass from "./index.module.css";
import { IoStar } from "react-icons/io5";

import Profile from "./Profile/profile";
import { Helmet } from "react-helmet";
import Activity from "./Activity/Activity";
import Communications from "./Communications";
import Actionbtns from "./Actionbtns";
import Review from "./Reviews";
import StarRating from "../../../../Components/Rating";
import Tabs from "./Tabs";
import Courses from "./course/course";
import { useNavigate } from "react-router-dom";
import { AccessKeys } from "../../../../Routes/config";
import { useSearchParams } from "react-router-dom";
import { AccessControl } from "../../../../Util/AccessControl";
import Earnings from "./Earnings/earnings";
import Payouts from "./Payouts/Payout";
import Batches from "./Batches/links";
import DemoConversioNFee from "./TutorConversion/links";

import CancellationReport from "./CancelReport/Report";
function Index() {
    const [searchParams] = useSearchParams();
    const Navigate = useNavigate();

    const [isActive, setIsActive] = useState("");
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [admindata, setadmindata] = useState(
        JSON.parse(localStorage.getItem("admindata")) || { Type: 1 }
    );
    useEffect(() => {
        if (searchParams.get("tab")) {
            setIsActive(searchParams.get("tab"));
        } else {
            setIsActive("Profile");
        }
    }, [searchParams.get("tab")]);
    const backButton = () => {
        Navigate(-1);
    };
    return (
        <Layout Active={"Tutor"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>
                    {data
                        ? `${data.FirstName} ${
                              data.LastName != "NA" && data.LastName
                          } `
                        : "Tutor"}
                </title>
            </Helmet>
            <div className={detailsClass["Container"]}>
                <button onClick={backButton} className={detailsClass["back"]}>
                    Back
                </button>
                <div className={detailsClass["wrapper"]}>
                    {data && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}>
                            <h3>
                                <span></span>Tutor:
                                {`${data.FirstName} ${
                                    data.LastName != "NA" && data.LastName
                                } `}{" "}
                                {AccessControl(AccessKeys.Tutor)?.edit ===
                                    1 && (
                                    <Actionbtns data={data} setData={setData} />
                                )}
                            </h3>
                            <StarRating
                                rating={data?.rating ? data?.rating : 0}
                                totalReviews={data?.totalReviews}
                                uniqueStudentsReviewed={
                                    data?.uniqueStudentsReviewed
                                }
                            />
                        </div>
                    )}

                    <Tabs
                        isActive={isActive}
                        setIsActive={setIsActive}
                        setLoading={setLoading}
                    />

                    {isActive === "Profile" && (
                        <Profile
                            loading={loading}
                            setLoading={setLoading}
                            data={data}
                            setData={setData}
                            admindata={admindata}
                        />
                    )}
                    {isActive === "Activity" && <Activity />}
                    {admindata?.Type != 14 && isActive === "Email" && (
                        <Communications />
                    )}
                    {isActive === "Review" && <Review />}
                    {isActive === "Courses" && <Courses />}
                    {admindata?.Type != 14 && isActive === "Earnings" && (
                        <Earnings />
                    )}
                    {admindata?.Type != 14 && isActive === "Payouts" && (
                        <Payouts />
                    )}
                    {admindata?.Type != 14 &&
                        isActive === "Demo Conversion Fee" && (
                            <DemoConversioNFee />
                        )}
                    {isActive === "Batches" && <Batches />}
                    {isActive === "CancellationReport" && (
                        <CancellationReport />
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Index;
